import type React from 'react';
import { useMatch } from 'react-router-dom';

import { Route } from 'src/constants';
import { useIsUserLoggedIn } from 'src/hooks/data/user';
import { AuthLayout } from './auth-layout/auth-layout';
import { MainLayout } from './main-layout/main-layout';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const isCalculatorRoute = !!useMatch(Route.CALCULATOR);
  const isDemoStandRoute = !!useMatch(Route.DEMO_STAND);
  const isUserLoggedIn = useIsUserLoggedIn();

  if (isDemoStandRoute) {
    return children;
  }

  if (isCalculatorRoute || isUserLoggedIn) {
    return <MainLayout isCalculatorRoute={isCalculatorRoute}>{children}</MainLayout>;
  }

  return <AuthLayout>{children}</AuthLayout>;
};
